import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typepayment";
var post = "/typepayment";
export const actGetDataTypepayment = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPEPAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEPAYMENT",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_TYPEPAYMENT", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPAYMENT",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataTypepayment = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPEPAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type payment has been created");
          dispatch(
            __openModal({ modal: "MODAL_ADD_TYPEPAYMENT", open: false })
          );
          return dispatch(actGetDataTypepayment());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEPAYMENT", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPAYMENT",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataTypepayment = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPEPAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type payment has been updated");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_TYPEPAYMENT", open: false })
          );
          return dispatch(actGetDataTypepayment());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEPAYMENT", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPAYMENT",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataTypepayment = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPEPAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEPAYMENT",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_TYPEPAYMENT", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPAYMENT",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataTypepayment = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPEPAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type payment has been deleted");
          return dispatch(actGetDataTypepayment());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEPAYMENT", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPAYMENT",
          message: "Network error..",
        });
      });
  };
};
